import React from 'react'

interface Props {
  width?: string
  height?: string
  fill?: string
}

const IconLocation = ({ width = '24px', height = '24px', fill = '#000' }: Props) => {
  return (
    <svg
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1024 1024"
      fill={fill}
    >
      <path d="M512 64c-176.7 0-320 143.3-320 320 0 224 320 576 320 576s320-352 320-576c0-176.7-143.3-320-320-320zm0 448c-70.7 0-128-57.3-128-128s57.3-128 128-128 128 57.3 128 128-57.3 128-128 128z" />
    </svg>
  )
}

export default IconLocation
